import React, { useState, useEffect } from "react";
import LandingComponent from "../Components/HomeComponents/LandingComponent";
import NavigationBar from "../Components/GlobalComponents/Navbar";
import ScrollingEffect from "../Components/HomeComponents/ScrollingEffect";

const Home = () => {
  const [showLanding, setShowLanding] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLanding(true);
    }, 3000); // Delay of 2 seconds

    return () => clearTimeout(timer); // Clean up the timer on component unmount
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column", // Stack components vertically
        maxHeight: "100vh", // Make sure the container takes full viewport height
        backgroundColor:"#F4F3F1;"
      }}
    >
      <NavigationBar />
      {showLanding &&<ScrollingEffect />}
     <LandingComponent />
    </div>
  );
};

export default Home;
